require("signature_pad");

(function($){
  var enableSignatures = false;
  var signatures = [];
  $('.signature-pad').each(function(index) {
    enableSignatures = true;
    var canvas = this;
    signatures[index] = new SignaturePad(canvas);

    function resizeCanvas() {
      var data = signatures[index].toDataURL(); //Added
      var ratio =  Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      canvas.getContext("2d").scale(ratio, ratio);
      signatures[index].fromDataURL(data);
    }
    resizeCanvas();
    window.addEventListener("resize", resizeCanvas, true);
  })
  if (enableSignatures) {
    $("form").on('submit', function(e) {
      var validForm = true;
      $(this).find('.signature-pad').each(function() {
        var index = $('.signature-pad').index($(this))
        if (signatures[index].isEmpty()) {
          validForm = false;
        }
        $('.signature-hidden').eq(index).val(signatures[index].toDataURL());
      })

      if (validForm == false) {
        e.preventDefault();
        alert("Signature can't be blank. Please sign signature box with your mouse or trackpad.");
        return false;
      }
    })

    $(document).on('click', '.clear-signature', function() {
      var index = $('.clear-signature').index($(this));
      signatures[index].clear();
    })

    $(document).on('click', '.adopt-signature', function() {
      var dataSig = $(this).data("signature");
      var index = $('.signature-pad').index($(this).closest('.signature-div').find('.signature-pad').eq(0));
      signatures[index].fromDataURL(dataSig);
    })
  }

})(jQuery)

// var cancelButton = document.getElementById('clear-signature');
// var cancelInitialButton = document.getElementById('clear-initial');
// var submitButton = document.getElementById('submit-with-signature');
// var submitButton2 = document.getElementById('sign-invoice');
// var submitStripeButton = document.getElementById('submit-stripe');

// document.addEventListener('DOMContentLoaded', function(){
//   const canvas = document.getElementById("JohnHancock-canvas");
//   const hidden_field = document.getElementById("JohnHancock-hidden");

//   if (canvas && hidden_field) {
//     signaturePad = new SignaturePad(canvas);

//     function resizeCanvas() {
//       var data = signaturePad.toDataURL(); //Added
//       var ratio =  Math.max(window.devicePixelRatio || 1, 1);
//       canvas.width = canvas.offsetWidth * ratio;
//       canvas.height = canvas.offsetHeight * ratio;
//       canvas.getContext("2d").scale(ratio, ratio);
//       //signaturePad.clear();
//       signaturePad.fromDataURL(data); //Added
//     }    

//     const initialCanvas = document.getElementById("Initial-canvas");
//     const initialHiddenField = document.getElementById("Initial-hidden");
  
//     if (initialCanvas && initialHiddenField) {
//       initialPad = new SignaturePad(initialCanvas);
  
//       function resizeInitialCanvas() {
//         var data = initialPad.toDataURL();
//         var ratio =  Math.max(window.devicePixelRatio || 1, 1);
//         initialCanvas.width = initialCanvas.offsetWidth * ratio;
//         initialCanvas.height = initialCanvas.offsetHeight * ratio;
//         initialCanvas.getContext("2d").scale(ratio, ratio);
//         initialPad.fromDataURL(data);
//       }    
  
//       window.addEventListener("resize", resizeInitialCanvas, true);
      
//       resizeInitialCanvas();
//       initialPad.clear();
  
//     }

//     const parent_form = canvas.closest("form");

//     parent_form.onsubmit = function() {
//       hidden_field.value = signaturePad.toDataURL()
//       initialHiddenField.value = initialPad.toDataURL()
//     }

//     window.addEventListener("resize", resizeCanvas, true);
    
//     resizeCanvas();
//     signaturePad.clear();

//   }
// }, false)

// if(cancelButton){
//   cancelButton.addEventListener('click', function (event) {
//     console.log("signature signaturePad.clear");
//     signaturePad.clear();
//   });
// };

// if(submitButton){
//   submitButton.addEventListener('click', function (event) {
//     checkEmptySignature();
//   });
// };

// if(submitButton2){
//   submitButton2.addEventListener('click', function (event) {
//     checkEmptySignature();
//   });
// };

// if(submitStripeButton){
// submitStripeButton.addEventListener('click', function (event) {
//   checkEmptySignature();
// });
// }

// function checkEmptySignature(event){
//   console.log("check if signature exists");
//   if (signaturePad.isEmpty()) {
//     console.log("Empty!");
//     alert("Signature can't be blank. Please sign signature box with your mouse or trackpad.");
//     event.preventDefault();
//     return false;
//   }else{
//     console.log("Nice sig bro!");
//     //event.preventDefault();
//     return true;
//   }
// }

// var initialPad;

// if(cancelInitialButton){
//   cancelInitialButton.addEventListener('click', function (event) {
//     initialPad.clear();
//   });
// };